'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import Link from 'next/link'
import { Pagination, PaginationItem } from '@mui/material'
import { ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material'

// Types
import type { PaginationProps } from '@/types/components/molecules/pagination'

// Utils
import SearchLink from '@/utils/search-link'

const PaginationMolecule = (props: PaginationProps) => {
	// Props
	const { count, page } = props

	// Variables
	const pathname = usePathname()
	const searchParams = useSearchParams()

	// Callbacks
	const createLink = (page: number | null): string => {
		// Create Params
		const reqParams: Record<string, string> = {}

		searchParams.forEach((param, index) => {
			if (index !== 'page') reqParams[index] = param
		})

		if (page && page > 1) reqParams.page = page.toString()

		return SearchLink(pathname, reqParams)
	}

	return (
		<Pagination
			page={page}
			count={count}
			shape="rounded"
			color="primary"
			size="large"
			sx={{
				'& .MuiPagination-ul': {
					justifyContent: 'center',
					bgcolor: '#f5f5f5',
					width: 'max-content',
					mx: 'auto',
					py: 0.5,
					borderRadius: 1
				}
			}}
			renderItem={item => (
				<Link href={createLink(item.page)}>
					<PaginationItem slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }} {...item} />
				</Link>
			)}
		/>
	)
}

export default PaginationMolecule
